<template>
    <div class="area-interesse">
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                    class="save-btn"
                    type="button"
                    @click="save()"
                    :disabled="isSaving"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
        <empty-table-message v-if="isEmpty" class="isEmpty" />
        <div v-else class="page-container form-columns-fit">
            <div class="areas">
                <div v-for="(area, index) in areasInteresse" :key="index">
                    <div class="titulo">
                        <div class="titulo-left">
                            <label
                                for="titulo"
                                :class="{ invalid: area.key == undefined || area.key.trim() == '' }"
                                v-text="$t(area.key)"
                            />
                            <b-icon 
                                icon="information" 
                                size="is-small" 
                                v-tippy 
                                :title="$t('msg-area-interesse-n', { n: $t(area.key) })"
                            />
                        </div>
                    </div>
                    <div class="area">
                        <div class="columns scroll-content">
                            <div
                                class="column is-2 is-full-mobile card-content-top"
                                v-for="(propValue, propName) in area.itens"
                                :key="propName"
                            >
                                <div class="switchClass">
                                    <div>
                                        <label>
                                            {{ $t(propValue.descricao) }}
                                        </label>
                                    </div>
                                    <b-switch
                                        :id="generateId(1)"
                                        v-model="propValue.isEnable"
                                        :title="
                                            propValue.isEnable ? $t('ativado') : $t('desativado')
                                        "
                                        :disabled="!permissao.update"
                                    >
                                        <span v-if="propValue.isEnable">{{ $t('desativar') }}</span>
                                        <span v-else>{{ $t('ativar') }}</span>
                                    </b-switch>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AssPermTelaRecursoFormularioService from '@/services/AssPermTelaRecursoFormularioService';

/**
 * @deprecated Essa classe foi depreciada e nao devera ser usada. 
 * Essa funcionalidade nao sera mais utilizada
*/
export default {
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            service: new AssPermTelaRecursoFormularioService(this.$http, this.$router),
            isSaving: false,
            isLoading: false,
            isEmpty: false,
            areasInteresse: [],
            assTelaRecurso: [],
            idFormulario: parseInt(this.$route.params.id),
            isVenda: this.$route.meta.contexto == 'vendas',
            isPromotor: this.$route.meta.contexto == 'promotor',
        };
    },
    created() {
        if (this.isPromotor) {
            this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'formulario');
        } else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess('vendas', 'formulario', 'ven-formulario');
        }
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'formularios' },
            });
        } else {
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: 'acesso-nao-permitido',
                    params: { tela: 'formularios' },
                });
            }
            if (this.idFormulario) {
                this.carregarDados();
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        carregarDados(param = '') {
            this.isLoading = true;

            this.service
                .findAllComboByIdFormulario(this.idFormulario, param)
                .then(this.mapItems)
                .then((content) => {
                    if (content) {
                        this.areasInteresse = this.mapRecursos(content);
                        this.isEmpty = this.areasInteresse.length <= 0;
                    }
                })
                .catch((e) => {
                    console.error('[AREA-INTERESSE] Erro ao carregar área de interesse.', e);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        mapItems({ content }) {
            return content.map((ass) => {
                return {
                    key: ass.sisPermTelaRecurso.descricaoModulo,
                    id: ass.idAssPermTelaRecursoFormulario,
                    idPermTelaRecurso: ass.sisPermTelaRecurso.idPermTelaRecurso,
                    descricao: ass.sisPermTelaRecurso.descricao,
                    isEnable: ass.sisPermTelaRecurso.isEnable,
                };
            });
        },
        mapRecursos(content) {
            // @87392 - transformacao feita para que cada tela esteja presente em seu modulo
            return Object.keys(content).reduce((accumulator, key) => {
                const contentKey = content[key].key;
                const existingEntry = accumulator.find((entry) => entry.key === contentKey);

                const object = this.getObject(content, key);
                if (existingEntry) {
                    existingEntry.itens.push(object);
                } else {
                    accumulator.push({ key: contentKey, itens: [object] });
                }

                return accumulator;
            }, []);
        },
        getObject(content, key) {
            return {
                id: content[key].id,
                idPermTela: content[key].idPermTelaRecurso,
                descricao: content[key].descricao,
                isEnable: content[key].isEnable,
            };
        },
        save() {
            this.mapTelasRecurso();

            if (this.assTelaRecurso.length > 0) {
                this.isSaving = true;
                this.service
                    .saveAreaInteresse(this.assTelaRecurso)
                    .then((body) => {
                        if (body.content === null) {
                            this.$root.showMessage('error', `${body.message}`, true);
                        } else {
                            let msg = 'msg-area-interesse-salva';
                            this.$root.showMessage('success', msg);

                            this.$emit('redirect');
                        }
                    })
                    .catch((e) => {
                        if (e.body && e.body.message && this.$te(e.body.message)) {
                            const message = e.body.message;
                            this.$root.showMessage('alert', message, true);
                        } else {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                        }
                    })
                    .finally((_) => {
                        this.isSaving = false;
                    });
            }
        },
        mapTelasRecurso() {
            this.assTelaRecurso = this.areasInteresse
                .map((item) =>
                    item.itens.map((item) => ({
                        idAssPermTelaRecursoFormulario: item.id,
                        idFormulario: this.idFormulario,
                        idPermTelaRecurso: item.idPermTela,
                        sisPermTelaRecurso: { isEnable: item.isEnable },
                    }))
                )
                .flat(); // Flatten the arrays into a single array
        },
    },
};
</script>

<style lang="scss" scoped>
@import './mixins.scss';

.area-interesse {
    margin-bottom: 20px;
    height: 100%;
    padding-top: 0;

    > h1 {
        padding-top: 20px;
        margin-bottom: 40px;
    }
    .isEmpty {
        height: 100%;
    }
    .page-container {
        height: auto;
    }

    .areas {
        position: relative;
        height: auto;
        width: 100%;

        .area {
            width: 100%;
            align-items: center;
            flex-wrap: wrap;
            margin-bottom: 15px;
            padding: 15px;
            border: solid 1px $table-border;
            border-radius: 3px;
        }

        .scroll-content {
            overflow-y: auto;
            height: 100%;
        }

        .titulo {
            width: 100%;

            .titulo-left {
                width: 50%;
            }

            label {
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                font-size: 15px;
                color: $sovis-black;
                padding-right: 5px;
            }
        }

        .card-content-top {
            padding-top: 0.25rem;
            padding-bottom: 0.25rem;
            .switchClass {
                text-align: left;
            }
        }
    }
}
</style>
